// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"e4e5b697","249":"cf792cc9","794":"20bd88a6","839":"2104d1e2","876":"073305f4"}[chunkId] + ".chunk.js";
};